"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const components_1 = require("@/components");
const constants_1 = __importStar(require("@/constants"));
const styles_scss_1 = __importDefault(require("./styles.scss"));
const BaseModal = ({ title, content, onModalClose, primaryButton, secondaryButton }) => (react_1.default.createElement("div", { className: styles_scss_1.default.container },
    react_1.default.createElement("button", { type: "button", className: styles_scss_1.default.closeButton, onClick: onModalClose },
        react_1.default.createElement("img", { src: constants_1.Images.cross, alt: constants_1.default.general.close })),
    react_1.default.createElement("h4", { className: styles_scss_1.default.title }, title),
    typeof content === 'string'
        ? react_1.default.createElement("p", { className: styles_scss_1.default.text }, content)
        : content,
    react_1.default.createElement("div", { className: styles_scss_1.default.buttonContainer },
        secondaryButton && (react_1.default.createElement(components_1.Button, { title: secondaryButton.title, onClick: secondaryButton.onClick })),
        primaryButton && react_1.default.createElement(components_1.Button, { title: primaryButton.title, onClick: primaryButton.onClick }))));
BaseModal.defaultProps = {
    primaryButton: undefined,
    secondaryButton: undefined
};
exports.default = BaseModal;
